import client from 'api/client';

function getOptions(endpoint: string) {
    return client.get(`select_options${endpoint}`);
}

export const getWorkPermitOptions = () => getOptions('/work_permit');
export const getNominationOptions = (country?: string) => {
    const endpoint = country === 'United Kingdom' ? '/nomination_uk' : '/nomination';
    return getOptions(endpoint);
};
export const getEducationOptions = () => getOptions('/education');
export const getFieldOfStudyOptions = (country: string) =>
    getOptions(`?country=${country}&category=field_of_study`);
export const getNationalityOptions = () => getOptions('/nationality');
export const getUkInstitutionOptions = () => getOptions('/institutions_uk');
export const getCaInstitutionOptions = () => getOptions('/institutions_ca');
export const getAuInstitutionOptions = () => getOptions('/institutions_au');
export const getCountryOptions = () => getOptions('/country');
export const getRegionOptions = () => client.get(`/select_options_regions`);
export const getFamilyRelationOptions = () => getOptions('/relation');
export const getBusinessSectorOptions = () => getOptions('/business_sector');
export const getRelationChild = () => getOptions('/relation_child');
export const getRelationNonChild = () => getOptions('/relation_non_child');
export const getIndexProfessions = (countryCode: string) => {
    const path = `?country_code=${countryCode}&category=occupation`;
    return getOptions(path);
};

function getCountrySpecificOptions(endpoint: string, country: string) {
    return client.get(`${endpoint}/${country}`);
}

export const getProfessions = (country: string) =>
    getCountrySpecificOptions('professions', country);

export const getResidencyOptions = (country: string) =>
    getCountrySpecificOptions('select_options_residency_status', country);

export const getPrevVisaOptions = (country: string) =>
    getCountrySpecificOptions('select_options_prev_visa', country);
